import { createSlice } from "@reduxjs/toolkit";

const printSaveSlice = createSlice({
  name: "printSave",
  initialState: {
    printData: null,
    saveData: null,
    loading: false,
    aDownload: false,
    printCleanModal: false,
    printPDFModal: false,
    origin: "",
    silent: false,
    message: "",
    showPrintSaveErrorModal: false,
    eventLabel: "",
    isPrint: false,
  },
  reducers: {
    setPrintData: (prevState, action) => {
      const state = prevState;
      state.printData = action.payload.printData;
    },
    setSaveData: (prevState, action) => {
      const state = prevState;
      state.saveData = action.payload.saveData;
    },
    setLoading: (prevState, action) => {
      const state = prevState;
      state.loading = action.payload.loading;
    },
    setADownload: (prevState, action) => {
      const state = prevState;
      state.aDownload = action.payload.aDownload;
    },
    setPrintCleanModal: (prevState, action) => {
      const state = prevState;
      state.printCleanModal = action.payload.printCleanModal;
    },
    setPrintPDFModal: (prevState, action) => {
      const state = prevState;
      state.printPDFModal = action.payload.printPDFModal;
    },
    setPrintSaveCallback: (prevState, action) => {
      const state = prevState;
      state.origin = action.payload.origin;
      state.message = action.payload.message;
    },
    printSaveCleanup: (prevState) => {
      const state = prevState;
      state.origin = "";
      state.message = "";
      state.printCleanModal = false;
      state.saveData = null;
      state.printData = null;
    },
    toggleShowPrintSaveErrorModal: (prevState) => {
      const state = prevState;
      state.showPrintSaveErrorModal = !prevState.showPrintSaveErrorModal;
    },
    setEventLabel: (prevState, action) => {
      const state = prevState;
      state.eventLabel = action.payload.eventLabel;
    },
    setIsPrint: (prevState, action) => {
      const state = prevState;
      state.isPrint = action.payload.isPrint;
    },
  },
});

export const {
  setPrintData,
  setSaveData,
  setLoading,
  setADownload,
  setPrintCleanModal,
  setPrintPDFModal,
  setPrintSaveCallback,
  printSaveCleanup,
  toggleShowPrintSaveErrorModal,
  setEventLabel,
  setIsPrint,
} = printSaveSlice.actions;

export const printDataSelector = (state) => state.printSave.printData;
export const saveDataSelector = (state) => state.printSave.saveData;
export const loadingSelector = (state) => state.printSave.loading;
export const aDownloadSelector = (state) => state.printSave.aDownload;
export const printCleanModalSelector = (state) => state.printSave.printCleanModal;
export const printPDFSelector = (state) => state.printSave.printPDFModal;
export const printSaveOriginSelector = (state) => state.printSave.origin;
export const printSaveMessageSelector = (state) => state.printSave.message;
export const showPrintSaveErrorModalSelector = (state) => state.printSave.showPrintSaveErrorModal;
export const isPrintSelector = (state) => state.printSave.isPrint;

export default printSaveSlice.reducer;
